/* import __COLOCATED_TEMPLATE__ from './sq-input-social-security-number.hbs.js'; */
import SqInputFormattedComponent from '@dashboard/shared-ui/components/sq-input-formatted';
import FieldKit from 'field-kit'; // eslint-disable-line import/default

export default class SqInputSocialSecurityNumber extends SqInputFormattedComponent {
  _getFormatter() {
    return new FieldKit.SocialSecurityNumberFormatter();
  }
}